import React from 'react';
import { useNavigate } from 'react-router-dom';

interface DrillToolbarProps {
  isAdmin?: boolean;
  isSuperUser?: boolean;
}

export const DrillToolbar: React.FC<DrillToolbarProps> = ({
  isAdmin = false,
  isSuperUser = false,
}) => {
  const navigate = useNavigate();

  if (!isAdmin && !isSuperUser) {
    return null;
  }

  return (
    <div className="toolbar toolbar-actions-only">
      <div className="toolbar-actions">
        {/* Primary creation actions - Admin only */}
        {isAdmin && (
          <>
            <button onClick={() => navigate('/training-drills/edit/new')} className="btn btn-success">
              + Add Drill
            </button>
            <button onClick={() => navigate('/training-drills/youtube-search')} className="btn btn-outline-primary">
              Import from YouTube
            </button>
          </>
        )}
        {/* Maintenance actions - visually separated, SuperUser only */}
        {isSuperUser && (
          <>
            {isAdmin && <span className="toolbar-divider" />}
            <button onClick={() => navigate('/training-drills/reseed')} className="btn btn-outline-danger btn-sm">
              Reseed Database
            </button>
          </>
        )}
      </div>
    </div>
  );
};
